// @greenlight-spec: 28-it-dashboard-ui.md
// @greenlight-spec: 11-observability.md#app-usage-collection
import * as React from 'react';

import { formatCountCompact, formatCountFull } from '@/components/greenlight/formatCount';
import type { AppUsageSummaryItem } from '@greenlight/shared';

const people = (n: number): string => `${formatCountCompact(n)} ${n === 1 ? 'person' : 'people'}`;

/**
 * Compact per-row usage signal for the apps list (IT-only, like the summary
 * read that feeds it). People only — request volume lives on app-detail
 * Monitoring, where the noise is easier to interpret.
 */
export function UsageSignal({
  usage,
  windowDays,
}: {
  usage: AppUsageSummaryItem | undefined;
  windowDays: number;
}): React.JSX.Element {
  // The summary carries a zero-valued row for every live app, so no row means
  // the read hasn't resolved (or the app is outside the live fleet) — dash, not 0.
  if (!usage) return <span className="text-muted-foreground">—</span>;
  const title = `${formatCountFull(usage.active_users)} active users on this app · last ${windowDays} days`;
  return (
    <span className="text-sm tabular-nums text-foreground" title={title}>
      {people(usage.active_users)}
    </span>
  );
}
